module.exports = __webpack_public_path__ + "img/box-money-inactive.8f16fc1c.svg";